/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { useGridApi } from '../Grid/hooks';
import { PoweredBasicFilter } from './components';

import type { PoweredBasicFilterProps } from './components';


export interface BasicFilterProps<ValueT> extends PoweredBasicFilterProps<ValueT> {
    name?: string;
}

export const BasicFilter = <ValueT,>(props: BasicFilterProps<ValueT>) => {
    const { name } = props;

    const gridApi = useGridApi();

    if (gridApi && name) {
        return (
            <PoweredBasicFilter
                value={gridApi.filters[name] as string[] || []}
                onChange={selectedIdItems => gridApi.applyFilters({
                    [name]: selectedIdItems,
                })}
                {...props}
            />
        );
    } else {
        return <PoweredBasicFilter {...props} />;
    }
};
